// extracted by mini-css-extract-plugin
export default {"createForumForm":"CreateForum_createForumForm__5ukNb","button":"CreateForum_button__von0M"};